import { ETyresCarType, TyreFilter } from "@tm/models"

export function hideSeasonsFilter(carTypes: TyreFilter[]) {
    return carTypes.some(
        (cartype) => cartype.value === ETyresCarType[ETyresCarType.Agrar] || cartype.value === ETyresCarType[ETyresCarType.Industrie]
    )
}
